import { CHARACTER_NAME_MAX_LENGTH, isCharacterDisplayName } from "../../character-catalog/character-names";

export interface AdminCharacterTextDraft {
  name: string;
  age: string;
  heightCm: string;
  profileText: string;
  positivePrompt: string;
}

function integerInRange(value: string, min: number, max: number): boolean {
  if (!/^\d+$/.test(value)) return false;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) && parsed >= min && parsed <= max;
}

export function validateAdminCharacterStep(step: number, draft: AdminCharacterTextDraft, hasPortrait: boolean, hasCover: boolean): string {
  if (step === 1) {
    if (!isCharacterDisplayName(draft.name.trim())) return `姓名须为1–${CHARACTER_NAME_MAX_LENGTH}个字符，不能含换行、控制字符或提及标记。`;
    if (!integerInRange(draft.age, 18, 120)) return "年龄必须是 18 到 120 的整数。";
    if (!integerInRange(draft.heightCm, 80, 250)) return "身高必须是 80 到 250 厘米的整数。";
    if (draft.profileText.trim().length === 0 || draft.profileText.length > 20_000) return "人设正文不能为空，且不能超过 20000 个字符。";
  }
  if (step === 2 && (draft.positivePrompt.trim().length === 0 || draft.positivePrompt.length > 4_000)) {
    return "正向题词不能为空，且不能超过 4000 个字符。";
  }
  if (step === 3 && !hasPortrait) return "请先选择并通过校验的 9:21 立绘。";
  if (step === 4 && !hasCover) return "请先选择并通过校验的 1:1 封图。";
  return "";
}

export function parseAdminCharacterNumbers(draft: AdminCharacterTextDraft): { age: number; height_cm: number } {
  return { age: Number(draft.age), height_cm: Number(draft.heightCm) };
}
